import { LETTER_POINTS } from './gameConfig';
import { RARITIES } from './rarityConfig';

export const SHOP_RARITY_CHANCES = Object.fromEntries(
  Object.entries(RARITIES).map(([key, def]) => [key, def.weight])
);

export const NEW_TILE_LETTER_CHANCES = Object.keys(LETTER_POINTS).reduce((acc, letter) => {
  acc[letter] = 1;
  return acc;
}, {});

